import * as React from 'react';
import Tabs from '../../../uiComponents/layout/Tabs';
import TabContent from '../../../uiComponents/layout/TabContent';
import { getLoggedInBruger } from '../../../infrastructure/Security';
import { BrugerRolleEnum } from '../../../models/enums/BrugerRolleEnum';
import { ContentWrapper } from '../../../uiComponents/layout/ContentWrapper';
import KonkurrenceOverblikPresenter from './KonkurrenceOverblikPresenter';
import { KonkurrenceOverblik } from '../../../models/KonkurrenceOverblik';

export interface KonkurrenceOverblikProps {
    konkurrenceId?: string;
    isLaererSkrivebord: boolean;
    konkurrenceOverblik?: KonkurrenceOverblik;
}

interface KonkurrenceOverblikStates {
    selectedHoldId?: string;
}

class KonkurrenceOverblikContainer extends React.Component<KonkurrenceOverblikProps, KonkurrenceOverblikStates> {
    constructor(props: KonkurrenceOverblikProps) {
        super(props);

        this.state = {
            selectedHoldId: undefined
        };

        this.getTabContent = this.getTabContent.bind(this);
    }

    componentDidMount() {
        if (this.props.konkurrenceOverblik !== undefined) {
            let firstHoldId = this.props.konkurrenceOverblik.hold[0].holdId;
            this.setState({
                selectedHoldId: firstHoldId
            });
        }
    }

    componentDidUpdate(prevProps: KonkurrenceOverblikProps) {
        if (this.props.konkurrenceOverblik !== undefined && this.props.konkurrenceOverblik !== prevProps.konkurrenceOverblik) {
            let firstHoldId = this.props.konkurrenceOverblik.hold[0].holdId;
            this.setState({
                selectedHoldId: firstHoldId
            });
        }
    }

    getPageTabs() {
        let tabs = new Map<number, string>();

        if (this.props.konkurrenceOverblik !== undefined) {
            for (var i = 0; i < this.props.konkurrenceOverblik.hold.length; i++) {
                let hold = this.props.konkurrenceOverblik.hold[i];
                const paaVentelisteNote = hold.erPaaVenteliste && !this.props.konkurrenceOverblik.hold.every(t => t.erPaaVenteliste) ? ' (på venteliste)' : '';
                tabs.set(i, 'Hold ' + hold.navn + paaVentelisteNote);
            }
        }

        return tabs;
    }

    getTabContent() {
        if (this.props.konkurrenceOverblik !== undefined) {
            let tabContents = [];
            for (var i = 0; i < this.props.konkurrenceOverblik.hold.length; i++) {
                let hold = this.props.konkurrenceOverblik.hold[i];
                let isActive = hold.holdId === this.state.selectedHoldId;

                tabContents.push(
                    <TabContent tabName={i.toString()} defaultActive={isActive} key={i}>
                        <KonkurrenceOverblikPresenter
                            konkurrencetitel={this.props.konkurrenceOverblik.konkurrenceTitel}
                            konkurrenceDate={this.props.konkurrenceOverblik.konkurrenceDate}
                            konkurrenceAfviklingssted={this.props.konkurrenceOverblik.konkurrenceAfviklingssted}
                            konkurrenceId={this.props.konkurrenceOverblik.konkurrenceId}
                            billedId={this.props.konkurrenceOverblik.billedId}
                            hold={hold}
                            beskrivelse={this.props.konkurrenceOverblik.beskrivelse}
                            showSamletPlacering={this.props.konkurrenceOverblik.showSamletPlacering}
                        />
                    </TabContent>
                );
            }

            return tabContents;
        }

        return [];
    }

    onTabChanged(selectedKey: number) {
        if (this.props.konkurrenceOverblik === undefined) {
            return;
        }
        const holdId = this.props.konkurrenceOverblik.hold[selectedKey].holdId;

        this.setState({
            selectedHoldId: holdId
        });
    }

    getActiveTabIndex(): number {
        if (this.props.konkurrenceOverblik === undefined) {
            return 0;
        }

        return this.props.konkurrenceOverblik.hold.findIndex(h => h.holdId === this.state.selectedHoldId);
    }

    render() {
        const bruger = getLoggedInBruger();

        let content = undefined;
        if (bruger.rolle === BrugerRolleEnum.Laerer) {
            content = (
                <Tabs
                    columns={this.getPageTabs()}
                    defaultColumnKey={this.getActiveTabIndex()}
                    onTabChanged={(selectedKey: number) => this.onTabChanged(selectedKey)}
                    isLaererSkrivebord={this.props.isLaererSkrivebord}
                >
                    {this.getTabContent()}
                </Tabs>
            );
        } else {
            content = (
                <ContentWrapper>
                    {this.props.konkurrenceOverblik !== undefined &&
                        <KonkurrenceOverblikPresenter
                            konkurrencetitel={this.props.konkurrenceOverblik.konkurrenceTitel}
                            konkurrenceDate={this.props.konkurrenceOverblik.konkurrenceDate}
                            konkurrenceAfviklingssted={this.props.konkurrenceOverblik.konkurrenceAfviklingssted}
                            konkurrenceId={this.props.konkurrenceOverblik.konkurrenceId}
                            billedId={this.props.konkurrenceOverblik.billedId}
                            hold={this.props.konkurrenceOverblik.hold[0]}
                            beskrivelse={this.props.konkurrenceOverblik.beskrivelse}
                            showSamletPlacering={this.props.konkurrenceOverblik.showSamletPlacering}
                        />
                    }
                </ContentWrapper>
            );
        }

        return (
            <div>
                {content}
            </div>
        );
    }
}

export default KonkurrenceOverblikContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/konkurrenceOverblik/KonkurrenceOverblikContainer.tsx